var map = {
	"./adult.svg": 256,
	"./angle-down-big.svg": 690,
	"./angle-down.svg": 691,
	"./aquarius.svg": 257,
	"./aries.svg": 258,
	"./arrow-album.svg": 90,
	"./attach.svg": 259,
	"./back-white.svg": 86,
	"./back.svg": 144,
	"./brush.svg": 692,
	"./burger-icon.svg": 203,
	"./cancer.svg": 260,
	"./capricorn.svg": 261,
	"./check-blue.svg": 132,
	"./check.svg": 130,
	"./checkbox-white.svg": 58,
	"./close-grey.svg": 693,
	"./close-red.svg": 262,
	"./close-white.svg": 145,
	"./close.svg": 85,
	"./clubs.svg": 69,
	"./comment.svg": 263,
	"./context-dark.svg": 91,
	"./context.svg": 146,
	"./delete-blue.svg": 147,
	"./delete.svg": 264,
	"./diamonds.svg": 66,
	"./dice-black.svg": 39,
	"./dice-blue.svg": 56,
	"./dice-dark-blue.svg": 265,
	"./dice-orange.svg": 199,
	"./dice-white.svg": 138,
	"./dice-yellow.svg": 266,
	"./dice.svg": 125,
	"./edit.svg": 694,
	"./eye.svg": 695,
	"./friends-icon.svg": 696,
	"./fullscreen-close.svg": 267,
	"./fullscreen-open.svg": 268,
	"./games-icon.svg": 697,
	"./gemini.svg": 269,
	"./heart-red.svg": 270,
	"./heart.svg": 271,
	"./hearts.svg": 67,
	"./image-puzzle.svg": 70,
	"./leo.svg": 272,
	"./libra.svg": 273,
	"./messages-icon.svg": 202,
	"./moderator_icon.svg": 60,
	"./mygreen-blue.svg": 128,
	"./mygreen-dark.svg": 274,
	"./mygreen-white.svg": 275,
	"./no-status.svg": 698,
	"./payment-way1.svg": 699,
	"./payment-way2.svg": 700,
	"./payment-way3.svg": 701,
	"./photo-delete.svg": 59,
	"./photo-likes.svg": 276,
	"./photo-prev.svg": 131,
	"./pisces.svg": 277,
	"./plane.svg": 87,
	"./profile-icon.svg": 702,
	"./puzzle.svg": 201,
	"./roulette-opener.svg": 126,
	"./roulette-timer-big.svg": 703,
	"./roulette-timer-mobile.svg": 704,
	"./roulette-timer.svg": 84,
	"./roulette-zero-choosen.svg": 140,
	"./roulette-zero.svg": 139,
	"./round-angle.svg": 705,
	"./sagittarius.svg": 278,
	"./scorpio.svg": 279,
	"./search.svg": 124,
	"./select-arrow.svg": 280,
	"./social-apple.svg": 205,
	"./social-facebook.svg": 706,
	"./social-google.svg": 206,
	"./social-yandex.svg": 207,
	"./spades.svg": 68,
	"./taurus.svg": 281,
	"./trash.svg": 707,
	"./unauth-burger.svg": 708,
	"./upload-avatar.svg": 148,
	"./video.svg": 35,
	"./virgo.svg": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 689;